import { UserInDto } from 'shared/domain/user/types/inDto';
import { UserEditApiResponse } from 'shared/domain/user/types/userInDtoGuards';
import {
  PermissionsChangeOutDto,
  UserCreateOutDto,
  UserLabelAndPhoneEditOutDto,
} from 'shared/domain/user/types/outDto';

export interface IUserUploader {
  POST: (url: string, data: unknown) => Promise<unknown>;
  PUT: (url: string, data: unknown) => Promise<unknown>;
  DELETE: (url: string) => Promise<unknown>;
  GET: (url: string) => Promise<unknown>;
}

export type UploadLabelAndPhoneUserChange = (
    uploader: IUserUploader,
    body: UserLabelAndPhoneEditOutDto,
    url: string
  ) => Promise<UserEditApiResponse[]>;

export type UploadPermissionsUserChange = (
    uploader: IUserUploader,
    body: PermissionsChangeOutDto,
    url: string
  ) => Promise<UserEditApiResponse[]>;

export type UploadUser = (
    uploader: IUserUploader,
    body: UserCreateOutDto,
    url: string
  ) => Promise<UserEditApiResponse>;

export type UploadUserDelete = (uploader: IUserUploader, url: string) => Promise<unknown>;

export function uploadUserLabelAndPhoneChange(
  uploader: IUserUploader,
  body: UserLabelAndPhoneEditOutDto,
  url: string
): Promise<UserEditApiResponse[]> {
  return uploader.PUT(url, body) as Promise<UserEditApiResponse[]>;
}

export function uploadUserPermissionsChange(
  uploader: IUserUploader,
  body: PermissionsChangeOutDto,
  url: string
): Promise<UserEditApiResponse[]> {
  return uploader.PUT(url, body) as Promise<UserEditApiResponse[]>;
}

export function uploadUser(
  uploader: IUserUploader,
  body: UserCreateOutDto,
  url: string
): Promise<UserEditApiResponse> {
  return uploader.POST(url, { ...body }) as Promise<UserEditApiResponse>;
}

export function uploadUserDelete(
  uploader: IUserUploader,
  url: string
): Promise<unknown> {
  return uploader.DELETE(url);
}
